import { render } from "./Mo_claimlist_row.vue?vue&type=template&id=8fedf270&scoped=true&ts=true"
import script from "./Mo_claimlist_row.vue?vue&type=script&lang=ts"
export * from "./Mo_claimlist_row.vue?vue&type=script&lang=ts"

import "./Mo_claimlist_row.vue?vue&type=style&index=0&id=8fedf270&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fedf270"]])

export default __exports__